<template>
  <div class="table">
    <!-- ---------------------------搜索框部分--------------------------- -->
    <div :style="'height:' + searchDivHeight + 'px'" @keypress="enterPress">
      <div class="theader" style="display: flex">
        <div ref="searchDiv" style="width:100%">
          <!-- //el-form添加@submit.native.prevent即可阻止表单提交的默认行为。 -->
          <el-form ref="form" label-width="80px" class="searchForm" @submit.native.prevent>
            <!-- 循环自定义搜索条件 -->
            <el-col v-for="(item, index) in searchData" :key="index" :span="(item.width == undefined ? 6 : item.width)">
              <template v-if="!item.hidden">
                <el-form-item :label="item.title+':'">
                  <!-- 时间范围 -->
                  <el-date-picker v-if="item.type=='daterange'" style="width: 100%;" value-format="yyyy-MM-dd" v-model="item.value" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>

                  <!-- 字典 -->
                  <dic v-else-if="item.type=='select' || item.type=='radio' || item.type=='checkbox'" v-model="item.value" :type="item.type" :dicCode="item.code"></dic>

                  <!-- 其它，默认字符串 -->
                  <el-input v-else size="small" style="width: 100%;" clearable v-model="item.value"></el-input>
                </el-form-item>
              </template>
            </el-col>

            <!-- 按钮部分 -->
            <el-col style="width:auto">
              <div class="searchAction" style="display: flex;margin-left:5px;margin-top:5px;">
                <el-button size="small" type="primary" @click="search" v-if="searchData.findIndex(x => !x.hidden) > -1"><i class="el-icon-search"></i>搜索</el-button>
                <el-button size="small" type="success" @click="refreshSearch" v-if="searchData.findIndex(x => !x.hidden) > -1"><i class="el-icon-refresh"></i>重置</el-button>
                <!-- 循环搜索栏自定义按钮 -->
                <el-button size="small" :type="item.type?item.type:'info'" v-for="(item,index) in searchBtn" :key="index" @click="searchBtnClick(item)" v-show="btnShow(item)"><i :class="item.icon"></i>{{item.title}}
                </el-button>
              </div>
            </el-col>
          </el-form>
        </div>
      </div>
    </div>
    <!-- ---------------------------搜索框结束--------------------------- -->

    <!-- ---------------------------列循环--------------------------- -->
    <div class="tcontent" :style="'height:' + tableHeight + 'px'">
      <el-table ref="Table" :data="tableData" border :height="'100%'" :header-cell-style="{ backgroundColor: '#f8f8f9!important', fontSize: '10px' }" @selection-change="handleSelectionChange" @sort-change="sortChange">
        <el-table-column fixed  type="selection" width="40"> </el-table-column>
        <!-- =====循环列======  -->
        <div :key="index" v-for="(colunmRow, index) in colunmData">

          <!-- 文本 -->
          <el-table-column  v-if="colunmRow.type == 'string' || colunmRow.type == 'input'  || colunmRow.type=='' || colunmRow.type==null" :align="colunmRow.align || 'left'" :prop="colunmRow.field" :label="colunmRow.title" :min-width="colunmRow.width || 150" :show-overflow-tooltip="true" :sortable="colunmRow.sort&& colunmRow.sort==true ?'custom':false">
            <template slot-scope="scope">
              <div style="display: flex">
                <!-- 列点击事件 -->
                <span class="columnClick" v-if="colunmRow.columnClick" @click="(e) => { colunmRow.columnClick && colunmRow.columnClick(scope.row) }">{{  colFormatter(scope.row,colunmRow.field,colunmRow)  }}</span>
                <span v-else> {{   colFormatter(scope.row,colunmRow.field,colunmRow)}}</span>
              </div>
            </template>
          </el-table-column>

          <!-- 时间列 -->
          <el-table-column v-else-if="colunmRow.type == 'date' || colunmRow.type == 'datetime'" :align="colunmRow.align || 'left'" :prop="colunmRow.field" :label="colunmRow.title" :min-width="colunmRow.width || 150" :sortable="colunmRow.sort">
            <template slot-scope="scopeDate">
              <span class="columnClick" v-if="colunmRow.columnClick" @click="(e) => { colunmRow.columnClick && colunmRow.columnClick(scopeDate.row) }">{{timeFormatter( scopeDate.row[colunmRow.field],colunmRow.type) }}</span>
              <span style="margin-left: 10px" v-else>{{timeFormatter( scopeDate.row[colunmRow.field],colunmRow.type) }}</span>
            </template>
          </el-table-column>

          <!-- 图片 -->
          <el-table-column v-if="colunmRow.type == 'img'" :align="colunmRow.align || 'left'" :prop="colunmRow.field" :label="colunmRow.title" :min-width="colunmRow.width || 150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template v-for="(img,index) in scope.row[colunmRow.field].split(',')">
                <el-image :key="index" v-if="img!=''" style="width: 50px; height: 50px; margin-left: 5px" :src="img" :preview-src-list="[img]">
                </el-image>
              </template>
            </template>
          </el-table-column>

          <!-- 字典 -->
          <el-table-column v-if="colunmRow.type == 'dic'" :align="colunmRow.align || 'left'" :prop="colunmRow.field" :label="colunmRow.title" :min-width="colunmRow.width || 150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template v-for="(img,index) in scope.row[colunmRow.field].split(',')">
                <el-image :key="index" v-if="img!=''" style="width: 50px; height: 50px; margin-left: 5px" :src="img" :preview-src-list="[img]">
                </el-image>
              </template>
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column min-width:150 v-else-if="colunmRow.type == 'action'" :align="colunmRow.align || 'left'" :label="colunmRow.title" :min-width="colunmRow.width || 100">
            <template slot-scope="scope">
              <div style="display: flex;flex-wrap:wrap">
                <div style="margin: 5px" v-for="(item, index) in colunmRow.btns" :key="index">
                  <el-button size="mini" :type="item.type =='text'?'text':''" v-if="isShow(scope.row, item)" @click="btnClick(scope.row, item, colunmRow.title)">
                    <i v-if="item.icon && item.icon != ''" :class="item.icon"></i> {{ item.btnText }}
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </div>
        <!-- ============循环结束============ -->
        
      </el-table>
    </div>
<!-- <div>
      <slot ></slot>
</div> -->
    <!-- 底部分页 -->
    <div class="tfoot" v-if="showpagination">
      <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pageData.Page" :page-sizes="[10,15, 20, 30, 50, 100]" :page-size="pageData.Size" layout="total, sizes, prev, pager, next, jumper" :total="pageData.Total">
      </el-pagination>
    </div>
    <!-- 分页结束 -->
  </div>
</template>

<script>
import dic from '../components/DicSelect.vue'
export default {
  name: "Table",
  components: {
     dic
  },
  props: {
    //通过调用组件传过来的值，可以直接用   
    url: {//请求接口的路径
      type: String,
      default: "",
    },
    column: {//[{field:'',title:'',width:'150',hidden:true}]
      type: Array,
      default: function () {
        return [];
      }
    },
    searchData: {//搜索数组   [{title:'姓名', name:'name',type:'text',length:4,hidden:true}]
      type: Array,
      default: function () {
        return [];
      }
    }, searchBtn: {//搜索按钮
      type: Array,
      default: function () {
        return [];
      }
    }, maxHeight: {//最高高度
      type: Number,
      default: () => {
        return 0;
      }
    }, data: {
      type: Array,
      default: function () {
        return null;
      }
    },autoLoad: {//是否自动加载数据
      type: Boolean,
      default: false,
    },dataChange: {//数据变化时触发
      type: Function,
      default: function () {
      }
    }
  },
  data() {
    return {
      selectData: [],
      colunmData: [],
      dicArr:[],
      dicData:[],
      tableHeight: window.innerHeight - 200,//表格高度
      searchDivHeight: 40,//搜索栏的高度
      tableData: [],//表格行数据
      pageData: { Page: 1, Size: 15, Total: 100 },//分页组件的数据信息
      PageIndex: 1,
      PageSize: 15,
      order: '',
      sort: '',
      IsAdd: false,
      showpagination: true,//显示分页
      where: [],//{ name: 'text', value: '1' }
    };
  }, watch: {
    data: {
      handler(data) {
        if (data) {
          this.tableData = data;
          this.$nextTick(() => { this.$refs.Table.doLayout() });//使用 doLayout可以重新布局。
        }
      },
      deep: true
    }
  },
  mounted() {
    this.searchDivHeight = this.$refs.searchDiv.offsetHeight + 7;//搜索栏的高度
    if (this.maxHeight == 0) {
      this.tableHeight = (window.innerHeight - (170 + this.searchDivHeight));//161是顶部的固定高度   
    } else {
      this.tableHeight = this.maxHeight;//161是顶部的固定高度   
    }
    this.colunmData = this.column;
    if (this.data) {//如果传进来的是数据，则直接显示数据，不用分页了。
      this.tableData = this.data;
      this.showpagination = false;
    } else if (this.autoLoad) {
      this.load();
    }
  },
  methods: {
    reload() {//重新加载数据
      this.load();
    },
    load() {//获取数据
      if (this.url.toString() == "") {
        return this.$message.error("获取数据接口地址不能为空");
      }
      this.where = [];
      for (let i = 0; i < this.searchData.length; i++) {
        let thisSearch = this.searchData[i];
        let value = thisSearch.value;
        if (thisSearch.type == 'daterange' && thisSearch.value && thisSearch.value.length == 2) {
          value = thisSearch.value[0] + ',' + thisSearch.value[1];
        }
        this.where.push({ name: thisSearch.name, value: value });
      }
      let paras = { PageIndex: this.PageIndex, PageSize: this.PageSize, Order: this.order, Sort: this.sort, wheres: this.where };
      this.http.post(this.url, paras, true).then((x) => {
        if (!x.Code) {
          return this.$message.error(x.Message);
        }
        let rowData = x.Data;
        this.tableData = rowData.Rows;
        this.pageData.Total = rowData.Total;

        if(this.dataChange)
        {
          this.dataChange&& this.dataChange(this.tableData);
        }
      });
      this.$nextTick(() => { this.$refs.Table.doLayout() });
    },
    enterPress() {//搜索回车事件
      if (event.keyCode == 13) {
        this.search();
      }
    },
    pageChange(index) {//翻页
      this.PageIndex = index;
      this.load();
    },
    sizeChange(size) {//调整页大小
      this.PageSize = size;
      this.PageIndex = 1;
      this.load();
    },
    btnClick(row, column, event) {//搜索栏自定义按钮点击事件
      column.click && column.click(row, column, event);
    },
    isShow(row, column) {//table的列是否显示
      if (!column.isShow) {
        return true;
      }
      return column.isShow && column.isShow(row, column);
    },
    search() {//搜索按钮
      this.load();
    }, resetTable() {//重置表格
      this.PageIndex = 1;
      this.pageData.Page = 1;
      this.load();
    }, searchBtnClick(item) {//搜索栏自定义按钮点击事件
      item.click && item.click();
    }, refreshSearch() {//重置搜索框内容
      let array = this.searchData;
      for (let index = 0; index < array.length; index++) {
        let element = array[index];
        if (element.hidden) {
          break;
        } else {
          element.value = '';
        }
      }
    }, timeFormatter(time, type) {//时间格式化
      let date = new Date(time);
      let dt = {
        y: date.getFullYear(),
        M: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds()
      };
      if (dt.M < 10) {
        dt.M = "0" + dt.M;
      }
      if (dt.d < 10) {
        dt.d = "0" + dt.d;
      }
      if (dt.h < 10) {
        dt.h = "0" + dt.h;
      }

      if (type == 'date') {
        return dt.y + '-' + dt.M + '-' + dt.d;
      } else {
        return dt.y + '-' + dt.M + '-' + dt.d + ' ' + dt.h + ':' + dt.m + ':' + dt.s;
      }
    }, handleSelectionChange(select) {//当勾选行的时候触发的事件
      this.selectData = select;
    }, getSelectData() {//获取所有选择行
      return this.selectData;
    }, colFormatter(row, field, col) {//自定义返回列的内容
      if (col.formatter) {
        return col.formatter(row);
      } else {
        return row[field];
      }
    }, sortChange(column) {//排序改变的时候
      this.sort = column.prop;
      this.order = column.order;
      this.PageIndex = 1;
      this.load();
    }, btnShow(e) {//是否显示搜索框中的按钮
      if (e.isShow) {
        return e.isShow();
      } else {
        return true;
      }

    }
  },
};
</script>
<style>
.columnClick {
  color: #00f;
  cursor: pointer;
}

.tfoot {
  width: 100%;
  text-align: right;
  border: solid 1px #ebeef5;
}

.searchForm .el-form-item {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Table.vue